import { styled as i } from "styled-components";
import { skeletonFadeAnimation as e } from "../../styles/animation.js";
const n = "--width", o = "--height", s = i.span`
  display: inline-flex;
  width: var(${n});
  height: var(${o});
  border-radius: 0.5ex;

  ${({ $animate: t }) => e({ animate: t })}
`;
export {
  s as Container,
  o as HEIGHT_VAR,
  n as WIDTH_VAR
};
